import {
  VHCRecordCheckBrakeItemTypes,
  VHCRecordCheckItemTypes,
  VHCRecordCheckWheelTyreItemTypes,
  VHCRecordItemGroups
} from 'api/generated';
import { VhcItem } from 'features/vhc/model';

export const getNewDuplicateName = (
  baseName: string,
  type: VHCRecordCheckItemTypes | VHCRecordCheckBrakeItemTypes | VHCRecordCheckWheelTyreItemTypes,
  group: VHCRecordItemGroups,
  items: VhcItem[]
): string => {
  const baseMatch = baseName.match(/^(.*?)(?:\s+#\d+)?$/);
  const originalName = baseMatch ? baseMatch[1] : baseName;

  const escaped = originalName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const existing = items.filter(
    (item) =>
      item.type === type &&
      item.group === group &&
      !item.isNew &&
      item.description?.match(new RegExp(`^${escaped}(?:\\s+#\\d+)?$`))
  );

  if (existing.length === 0) {
    return originalName;
  }

  let maxNum = 0;
  existing.forEach((item) => {
    const m = item.description!.match(new RegExp(`^${escaped}\\s+#(\\d+)$`));
    if (m) {
      const num = parseInt(m[1], 10);
      if (!isNaN(num) && num > maxNum) {
        maxNum = num;
      }
    }
  });

  const next = maxNum === 0 ? 2 : maxNum + 1;
  return `${originalName} #${next}`;
};
